import { render, staticRenderFns } from "./EmergencyCase.vue?vue&type=template&id=1863d421&"
import script from "./EmergencyCase.vue?vue&type=script&lang=ts&"
export * from "./EmergencyCase.vue?vue&type=script&lang=ts&"
import style0 from "./EmergencyCase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports